import styled from 'styled-components'

export const Box = styled.div`
    height: ${props => props.size + 'px'};
    width: ${props => props.size + 'px'};
    position: relative;
`
